import { HttpParams } from "@angular/common/http";
import { forwardRef, Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { WORK_ORDER_BY_ID } from "../common/endpoints";
import { WorkOrder } from "../model";
import { HttpService } from "./http.service";

@Injectable()
export class WorkOrderService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }

    getById(id: string, isHistorical: boolean): Promise<WorkOrder> {
        const params = new HttpParams().set('historical', isHistorical);
        return firstValueFrom(this.httpService.get<WorkOrder>(WORK_ORDER_BY_ID.replace('{id}', id), params));
    }

    updateWorkOrder(id: string, body: any, isHistorical: boolean): Promise<WorkOrder> {
        const params = new HttpParams().set('historical', isHistorical);
        return firstValueFrom(this.httpService.put<WorkOrder>(WORK_ORDER_BY_ID.replace('{id}', id), body, params));
    }
}